import React, {useState, useEffect} from "react";
import {
    Bell,
    Calendar,
    ShoppingBag,
    MoreHorizontal,
} from "lucide-react";

export const BackOfficeSection = () => {
    const isVisible = (elementOffset) => {
        return scrollY > elementOffset - window.innerHeight + 100;
    };

    const BackOfficeFeature = ({icon, title, description}) => {
        return (
            <div className="flex gap-4 items-start group hover:bg-white/5 p-4 rounded-xl transition">
                <div
                    className="w-12 h-12 bg-[#FF4D00]/20 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#FF4D00]/30 transition">
                    {React.cloneElement(icon, {className: "w-6 h-6 text-[#FF4D00]"})}
                </div>
                <div>
                    <h3 className="text-xl font-semibold mb-2">{title}</h3>
                    <p className="text-gray-400">{description}</p>
                </div>
            </div>
        );
    };

    return (
        <section className="py-20 px-4 bg-gradient-to-b to-[#1a1a1a] relative">
            <div className="max-w-6xl mx-auto relative z-10">
                <div
                    className={`transform transition-all duration-1000 ${
                        isVisible(1000)
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-10"
                    }`}
                >
                    <h2 className="text-4xl/[1.5] font-bold text-center mb-6 text-[#FF4D00] bg-clip-text">
                        Powerful Back Office Tools
                    </h2>
                    <p className="text-xl text-center text-gray-400 mb-16 max-w-2xl mx-auto">
                        Manage your festival efficiently with our comprehensive
                        administration platform
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-8">
                            <BackOfficeFeature
                                icon={<Bell/>}
                                title="Instant Notifications"
                                description="Send real-time updates and important announcements to all festival guests instantly"
                            />
                            <BackOfficeFeature
                                icon={<Calendar/>}
                                title="Running Order Management"
                                description="Easily manage and update the festival schedule with immediate app synchronization"
                            />
                            <BackOfficeFeature
                                icon={<ShoppingBag/>}
                                title="Merchandise Control"
                                description="Track inventory, manage sales, and update merchandise listings in real-time"
                            />
                            <BackOfficeFeature
                                icon={<MoreHorizontal/>}
                                title="Future Expandability"
                                description="Many more features planned including analytics, crowd management, and vendor integration"
                            />
                        </div>

                        <div className="flex items-center">
                            <div className="overflow-hidden rounded-2xl">
                                <img
                                    className="mx-auto"
                                    src={require("../assets/helga_backoffice.jpg")}
                                    alt="Backoffice"
                                    style={{width: "75%", height: "auto"}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
